<script>
    import R, {LOADER} from "../../lib/requests";
    import {flip} from 'svelte/animate';
    import AnalysesSearchControl from "../../components/controls/AnalysesSearchControl.svelte";
    import Notifier from "../../stores/notifier";
    import Checkbox from "../../components/controls/Checkbox.svelte";
    import AppIcon from "../../components/icons/AppIcon.svelte";


    export let group = null;
    export let closeCallback;

    let groupId;
    let list = null;
    let selected = [];
    let hovering = false;

    const load = () => {
        const onSuccess = result => {
            list = result;
            list.map(item => {
                item.is_checked = 1;
            });
        }

        const onFailure = err => {
        };

        let data = {
            group_id: groupId,
            sort_field: 'view_index',
        }

        R.handle(R.analyses.index, data, onSuccess, onFailure, LOADER.POPUP);
    }

    const save = () => {
        const onSuccess = result => {
            list = result;
            list.map(item => {
                item.is_checked = 1;
            });
            Notifier.showMessage("Η ομάδα αναλύσεων ενημερώθηκε");
        }

        const onFailure = err => {
        };

        let analyses = list.filter(x => x.is_checked == 1).map(item => (item.id));
        let data = {
            id: groupId,
            analyses
        }

        R.handle(R.analysisGroup.editAnalyses, data, onSuccess, onFailure, LOADER.POPUP);
    }

    const onSelect = ({detail}) => {
        detail.map(item => {
            let listItem = list.find(x => x.id == item.id);
            if (!listItem) {
                list = [...list, item];
            }
        });
    }

    /* Drag drop handlers */
    const dragstart = (event, i) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.dropEffect = 'move';
        event.dataTransfer.setData('text/plain', i);
    }

    const drop = (event, target) => {
        event.dataTransfer.dropEffect = 'move';
        const start = parseInt(event.dataTransfer.getData("text/plain"));
        const newTracklist = list;

        if (start < target) {
            newTracklist.splice(target + 1, 0, newTracklist[start]);
            newTracklist.splice(start, 1);
        } else {
            newTracklist.splice(target, 0, newTracklist[start]);
            newTracklist.splice(start + 1, 1);
        }
        list = newTracklist;
        hovering = null;
    }

    $: {
        if (group.id != groupId) {
            groupId = group.id;
            load();
        }
        selected = list ? list.filter(x => x.is_checked == 1).map(item => (item.id)) : [];
    }
</script>

{#if group}
    <div class="panel panel-default">
        <div class="panel-heading">
            <div class="title">{ group.name }</div>
            <div class="close" on:click={ closeCallback }>
                <AppIcon icon="x" strokeWidth="2" size="16"/>
            </div>
        </div>
        <div class="panel-body panel-pad">
            <AnalysesSearchControl {selected} on:select={ onSelect }/>
            <hr>
            {#if list}
                {#if list.length}
                    <div class="group-analyses">
                        {#each list as item, index (item.id)}
                            <div class="group-item"
                                 animate:flip="{{ duration: 100 }}"
                                 draggable={true}
                                 on:dragstart={event => dragstart(event, index)}
                                 on:drop|preventDefault={event => drop(event, index)}
                                 ondragover="return false"
                                 on:dragenter={() => hovering = index}
                                 class:drag-over={hovering === index}
                            >
                                <div class="checkbox">
                                    <Checkbox bind:checked={ item.is_checked }/>
                                </div>
                                <div class="code text-gray">{ item.code }</div>
                                <div class="parameter">{ item.name_el }</div>
                                <div class="material text-gray">{ item.material }</div>
                            </div>
                        {/each}
                    </div>
                {:else}
                    Δεν υπάρχουν αναλύσεις σε αυτή την ομάδα.
                {/if}
            {/if}
            <hr>
            <div class="text-end">
                <button class="btn btn-link me-3" on:click={ closeCallback }>Κλείσιμο</button>
                <button class="btn btn-primary" on:click={ save }>ΕΝΗΜΕΡΩΣΗ</button>
            </div>
        </div>

    </div>
{/if}

<style>
    .group-analyses {

    }

    .group-analyses .group-item {
        display: flex;
        align-items: center;
        padding: 8px 0;
        border-bottom: 1px dotted #c6d2d9;
    }

    .group-analyses .group-item:last-child {
        border-bottom: none;
    }

    .group-analyses .group-item:hover {
        background: rgba(0, 0, 0, 0.04);
    }

    .group-analyses .group-item .checkbox {

    }

    .group-analyses .group-item .code {
        width: 40px;
    }

    .group-analyses .group-item .parameter {
        width: calc(100% - 70px - 200px);
    }

    .group-analyses .group-item .material {
        width: 200px;
        text-align: right;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>